import apiBase from "../../../api/axios";

export const getFrasesSeleccionAplicacionPlantelService = async (
  plantelId,
  page = 1,
  search = ""
) => {
  let url = `v1/talentos-plantel/frases-seleccion-aplicacion/?page=${page}&plantel=${plantelId}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  const response = await apiBase.get(url);
  return response.data;
};

export const getFraseSeleccionAplicacionPlantelByIdService = async (id) => {
  const response = await apiBase.get(
    `v1/talentos-plantel/frases-seleccion-aplicacion/${id}/`
  );
  return response.data;
};

export const updateFraseSeleccionAplicacionPlantelService = async (id, payload) => {
  const response = await apiBase.put(
    `v1/talentos-plantel/frases-seleccion-aplicacion/${id}/`,
    payload
  );
  return response.data;
};

export const createFraseSeleccionAplicacionPlantelService = async (payload) => {
  const response = await apiBase.post(
    `v1/talentos-plantel/frases-seleccion-aplicacion/`,
    payload
  );
  return response.data;
};

export const toggleFraseSeleccionAplicacionPlantelActiveService = async (id) => {
  const response = await apiBase.post(
    `v1/talentos-plantel/frases-seleccion-aplicacion/${id}/toggle_active/`
  );
  return response.data;
};